'use client';
function setAddMany(set, items, allowFalsy = false) {
    for (const item of items){
        if (allowFalsy || !!item) {
            set.add(item);
        }
    }
    return set;
}
function setToString(set, separator = ' ') {
    return Array.from(set).filter(Boolean).join(separator);
}

export { setAddMany, setToString };
